import { Grid } from "@mui/material"
import MDBox from "components/MDBox"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import Header from "examples/Header"
import WeeklyCalendar from "./components/WeeklCalendar"
import MonthCalendar from "./components/MonthCalendar"
import calendarStyles from "./style"
import { useCallback, useEffect, useState } from "react"
import moment from "moment"
import { useMyDevelopmentAPIs } from "shared/redux/endpoints/endPointMyDevelopment"
import { useDispatch, useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"
// import type { Error400 } from "utilities/toastUtil";
import { ToastUtil } from "utilities/toastUtil"
import { resetCallGetCalendarWorkshop } from "shared/redux/slices/sliceMyCalendar"
import WeeklyCalendarLXO from "components/WeeklyCalendarLXO/WeeklyCalendarLXO"
import { RoleLabel } from "constant/Role"
import { Role } from "constant/Role"
import TeacherManagementCalendarSection from "components/TeacherManagementCalendarSection/TeacherManagementCalendarSection"
import ModalWorkShop from "components/ModalWorkShop/ModalWorkShop"
import ModalLeaveApplication from "components/ModalLeaveApplication/ModalLeaveApplication"
import ModalLeaveRelatedInfomation from "components/ModalLeaveRelatedInfomation/ModalLeaveRelatedInfomation"
import ModalMyCalendarStudentAtRisk from "components/ModalMyCalendarStudentAtRisk/ModalMyCalendarStudentAtRisk"

import { useLazyGetLeaveCalenDarQuery } from "shared/redux/endpoints/lxo"
// import type { IWeeklyCalendarProps } from "./components/WeeklCalendar";

const tabs = [
  { label: "All", value: "all" },
  {
    label: "Lesson",
    value: "session",
  },
  {
    label: "Demo/PT",
    value: "pt",
  },
  {
    label: "Tasks",
    value: "task",
  },
  {
    label: "EOCC & Test",
    value: "test",
  },
  {
    label: "Training/Workshop",
    value: "training",
  },
  { label: "Events", value: "events" },
  { label: "Teacher Calendar", value: "teacher-calendar" },
]

function MyCalendar() {
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const role = auth.role
  const { user } = auth
  const [start, setStart] = useState(
    moment().startOf("isoWeek").weekday(1).format("YYYY-MM-DD")
  )
  const [dataRelatedInformation, setDataRelatedInformation] = useState([])
  const [tab, setTab] = useState([tabs[0]])

  const [end, setEnd] = useState(
    moment().startOf("isoWeek").weekday(7).format("YYYY-MM-DD")
  )

  const [triggerCalendarLeave, { data: leaveData }] =
    useLazyGetLeaveCalenDarQuery()

  const [payloadSubmit, setPayloadSubmit] = useState({})
  const [isOpenModalLeave, setIsOpenModalLeave] = useState(false)
  const [
    isOpenModalLeaveRelatedInformation,
    setIsOpenModalLeaveRelatedInformation,
  ] = useState(false)

  // get instance call API
  const getDataPageOfWorkshopTab =
    useMyDevelopmentAPIs.useGetDataPageOfWorkshopTab()

  // func call API
  const callGetDataPageOfWorkshopTab = useCallback(async () => {
    let email = user.email
    await getDataPageOfWorkshopTab({ email }, undefined, undefined, (error) => {
      ToastUtil.showToastError400(error)
    })
  }, [getDataPageOfWorkshopTab])

  // result API
  const { dataWorkShop } = useSelector(
    (state) => state.myCalendar.callGetCalendarWorkshop
  )

  const propertiesWeeklyCalendar = {
    outerDate: start,
    dataWorkShop: dataWorkShop,
    onChangeTab: async (tab) => {
      if (tab.value === "all" || tab.value === "training") {
        await callGetDataPageOfWorkshopTab()
      } else {
        dispatch(resetCallGetCalendarWorkshop())
      }
    },
  }

  const propertiesMonthCalendar = {
    start,
    setStart,
    end,
    setEnd,
    dataWorkShop,
  }

  const propsModalLeaveRelatedInformation = {
    isOpen: isOpenModalLeaveRelatedInformation,
    onClose: () => setIsOpenModalLeaveRelatedInformation(false),
    onSubmit: async () => {
      try {
        const dataSubmit = {
          leaveType: payloadSubmit?.leaveType?.value,
          startDate: moment(payloadSubmit.fromDate).format("YYYY-MM-DD"),
          endDate: moment(payloadSubmit.toDate).format("YYYY-MM-DD"),
          dayType: payloadSubmit.isHalfDay ? "HALF_DAY" : "FULL_DAY",
          reason: payloadSubmit.reason ?? "Medical leave",
          approverId: payloadSubmit.approver?.userId,
          notificationRecipientIds: payloadSubmit.notifyTo?.map((u) => u.id),
        }
        const formData = new FormData()
        formData.append(
          "request",
          new Blob([JSON.stringify(dataSubmit)], { type: "application/json" })
        )

        payloadSubmit?.attachments?.length > 0 &&
          payloadSubmit.attachments.forEach((file) => {
            formData.append("attachments", file)
          })
        await createLeaveRequest(formData).unwrap()
        setIsSubmitSuccess(true)
      } catch (e) {
        setIsSubmitSuccess(false)
      }
      setIsOpenModalLeaveRelatedInformation(false)
      setIsOpenModalLeaveSubmitStatus(true)
    },
    dataRelatedInformation: dataRelatedInformation,
  }

  const propsModalLeaveApplication = {
    isOpen: isOpenModalLeave,
    onClose: () => setIsOpenModalLeave(false),
    onSubmit: (data) => {
      setPayloadSubmit(data)
      setIsOpenModalLeave(false)
      setIsOpenModalLeaveRelatedInformation(true)
    },
  }

  const propsTeacherManagementCalendarSection = {
    tab,
    setTab,
  }

  useEffect(() => {
    if (!start || !end) return
    const fetchData = async () => {
      try {
        await triggerCalendarLeave({
          startDate: start,
          endDate: end,
        })
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }
    fetchData()
  }, [start, end, tab])

  return (
    <DashboardLayout>
      <Header />
      <MDBox sx={calendarStyles}>
        <MDBox
          sx={() => ({
            width: "100%",
          })}
        >
          <Grid container columnSpacing={2} rowGap={2}>
            <Grid item xs={12} xl>
              {role === RoleLabel[Role.LXO] ? (
                <WeeklyCalendarLXO
                  outerDate={start}
                  start={start}
                  end={end}
                  setStart={setStart}
                  setEnd={setEnd}
                  leaveData={leaveData}
                />
              ) : (
                <WeeklyCalendar
                  outerDate={start}
                  onChangeTab={setTab}
                  leaveData={leaveData}
                  setStart={setStart}
                  setEnd={setEnd}
                />
              )}
            </Grid>
            <Grid
              item
              xs={12}
              xl="auto"
              mb={{ xs: 3, xl: 0 }}
              sx={({ breakpoints }) => ({
                [breakpoints.down(1294)]: {
                  width: "100%",
                },
              })}
            >
              <MonthCalendar {...propertiesMonthCalendar} />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      {isOpenModalLeave && (
        <ModalLeaveApplication {...propsModalLeaveApplication} />
      )}
      {isOpenModalLeaveRelatedInformation && (
        <ModalLeaveRelatedInfomation {...propsModalLeaveRelatedInformation} />
      )}
    </DashboardLayout>
  )
}

export default MyCalendar
